<template>
  <div class="d-flex flex-column align-center">
    <h1 class="text-center mb-2">
      {{ $t('settings.upgrade-onboarding.title', { newPackage }) }}
    </h1>

    <div v-if="hasGuideStep && step === getStep('Landingpages')">
      <div class="d-flex justify-center">
        <span class="text-subtitle-2 text-center">
          {{ $t('settings.upgrade-onboarding.subtitle', { newPackage }) }}<br />
          {{ $t('settings.upgrade-onboarding.info') }}
        </span>
      </div>

      <Landingpages
        class="px-4"
        :count-of-guides="1"
        v-bind="landingpageDataProps"
        hide-description
        hide-secondary-actions
        @next-step="handleNextStep"
        @dirty="handleDirty"
      />
    </div>
    <div v-if="step === getStep('Publikation')">
      <div
        id="publicationForm"
        ref="publicationForm"
        class="d-flex justify-center mb-4"
      >
        <span class="text-subtitle-2 text-center">
          {{ $t('settings.upgrade-onboarding.body-texts.0') }}<br />
          {{ $t('settings.upgrade-onboarding.body-texts.1') }}
        </span>
      </div>
      <v-alert
        type="warning"
        variant="tonal"
      >
        {{ $t('settings.upgrade-onboarding.body-texts.2') }}
      </v-alert>

      <Publication
        v-if="step === getStep('Publikation')"
        class="px-4"
        v-bind="publicationDataProps"
        :is-onboarding="true"
        hide-secondary-actions
        @next-step="$emit('submit')"
        @dirty="handleDirty"
      />
    </div>
  </div>
</template>

<script>
import featureMixin from '@/mixins/feature'
import Publication from '@/modules/company/Publication'
import Landingpages from '@/modules/onboarding/Landingpages.vue'

const PREVIEWS = {
  ATV1: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  CHV1: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  CHV2: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  DV1: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  DV2: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  DV3: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  DV4: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
  REMAX:
    'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau-remax/Ratgeber-Vorschau.pdf',
  VOBA: 'https://static.bottimmo.com/assets/onboarding/previews/250410_Ratgeber-Vorschau/Ratgeber-Vorschau.pdf',
}

export default {
  components: {
    Landingpages,
    Publication,
  },
  mixins: [featureMixin],
  props: {
    newPackage: {
      type: String,
      default: '',
    },
    company: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      isDirty: false,
      missingData: {},
      products: [],
    }
  },
  computed: {
    landingpageDataProps() {
      const { id: companyId, variant, country, bookedLandingpageSlugs } = this.company
      return {
        companyId,
        variant,
        country,
        bookedLandingpageSlugs,
      }
    },
    steps() {
      const steps = [
        { route: 'landigpages', title: 'Landingpages', disabled: !this.hasGuideStep },
        { route: 'publication', title: 'Publikation' },
      ]

      return steps
        .filter(({ disabled }) => !disabled)
        .map((step, index) => ({ ...step, step: index + 1 }))
    },
    hasGuideStep() {
      return (
        this.isFeatureActive(this.featureNames.LANDINGPAGE) &&
        this.getFeature(this.featureNames.LANDINGPAGE)?.config.canBookLandingpages
      )
    },
    publicationDataProps() {
      const {
        id: companyId,
        slogan,
        ambassador,
        name,
        links,
        address,
        mailProvider,
        images: { team, logo, office, region },
        variant,
        theme,
        isReferenceCustomer,
      } = this.company
      return {
        companyId,
        slogan,
        name,
        links,
        address,
        mailProvider,
        previewLink: PREVIEWS[variant],
        theme: {
          ...theme,
          colors: {
            ...theme.colors,
            primary: theme.colors.primary || '#000000',
            secondary: theme.colors.secondary || '#000000',
          },
        },
        isReferenceCustomer,
        ambassador: {
          ...ambassador,
          image: ambassador.image || {},
        },
        images: {
          team: team || {},
          logo: logo || {},
          office: office || {},
          region: region || {},
        },
      }
    },
  },
  methods: {
    handleNextStep(value = 1) {
      this.$emit('scrollToTop')
      const nextStep = this.step + value
      this.step = nextStep < 1 ? 1 : nextStep
    },
    handleDirty(value) {
      this.isDirty = value
    },
    getStep(title) {
      return this.steps.find((step) => step.title === title)?.step
    },
  },
  emits: ['scrollToTop', 'submit'],
}
</script>
